import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { pln } from './format';
import { useTranslation } from 'react-i18next';

// Koszt preferencji (§preference_costs): dla preferencji niespełnionej przez żaden
// wariant — komunikat z API + przycisk podnoszący budżet do tej kwoty i ponowne szukanie.
const PreferenceCostsNote = ({ items, onRaiseBudget, kosztyWlasneZl = 0 }) => {
  const { t } = useTranslation('asystent');
  if (!items || items.length === 0) return null;
  return (
    <div className="mt-5 space-y-2">
      {items.map((pc, i) => (
        <div key={i} className="rounded-xl border border-amber-200 bg-amber-50 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
          <FontAwesomeIcon icon={faWallet} className="text-amber-500 shrink-0 hidden sm:block" />
          <p className="text-sm text-amber-800 flex-1">{pc.message_pl}</p>
          {/* Kwota z silnika to produkty i dostawa; pole budżetu jest budżetem
              ŁĄCZNYM, więc doliczamy konstrukcję i montaż — inaczej po kliknięciu
              budżet dalej byłby za niski (patrz NoResults). */}
          {pc.cheapest_total_pln != null && (
            <button
              type="button"
              onClick={() => onRaiseBudget(pc.cheapest_total_pln + (kosztyWlasneZl || 0))}
              className="shrink-0 px-3 py-2 rounded-lg bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
            >
              {t('koszt_preferencji.podnies', { kwota: pln(pc.cheapest_total_pln + (kosztyWlasneZl || 0)) })}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default PreferenceCostsNote;
